export const activitiesRoutes = {
	bingo: '/activities/bingo',
	flashcards: '/activities/flashcards',
	writingPractice: '/activities/writing-practice',
	sightWords: '/activities/sight-words',
};
